
export class Teams {
    Handel:boolean = false;
    Prod:boolean = false;
    Studio:boolean = false;
    Zakupy:boolean = false;
    Technologia:boolean = false;
    Quality:boolean = false;
    Planista:boolean = false;
    JM:boolean = false;
}



export class TeamsWebhooks {
    Handel: string = 'https://grafpol.webhook.office.com/webhookb2/c8d94224-4bab-4321-9112-2808876b69f5@7e34a445-4e65-4d9e-ab09-1b4049dbd381/IncomingWebhook/5edb0047a1ef47f69d1385d997b5e66f/64936cee-420e-4608-bd6f-9df66783683f'
    Prod: string = 'https://grafpol.webhook.office.com/webhookb2/3fef2b29-c95c-4f11-8978-b7c3842e9605@7e34a445-4e65-4d9e-ab09-1b4049dbd381/IncomingWebhook/44107493c0f84f0488d65fc7e1853b33/64936cee-420e-4608-bd6f-9df66783683f'
    Studio: string = 'https://grafpol.webhook.office.com/webhookb2/f265ba74-fcb3-42ef-a712-aa61a775b98e@7e34a445-4e65-4d9e-ab09-1b4049dbd381/IncomingWebhook/db564a810fff46a6a17c2bb8eb9399fe/64936cee-420e-4608-bd6f-9df66783683f'
    Zakupy: string = 'https://grafpol.webhook.office.com/webhookb2/1bd183e1-1a64-4b64-9f12-6c86fae25cdb@7e34a445-4e65-4d9e-ab09-1b4049dbd381/IncomingWebhook/79708448173e4f8ebc7cfcc06e3f8c98/64936cee-420e-4608-bd6f-9df66783683f'
    Technologia: string = 'https://grafpol.webhook.office.com/webhookb2/83700551-ac8c-4564-859b-9ceb2bd47605@7e34a445-4e65-4d9e-ab09-1b4049dbd381/IncomingWebhook/bb2ce2732294403f83e2f4b4cb129c98/64936cee-420e-4608-bd6f-9df66783683f'
    Quality: string = 'https://grafpol.webhook.office.com/webhookb2/83700551-ac8c-4564-859b-9ceb2bd47605@7e34a445-4e65-4d9e-ab09-1b4049dbd381/IncomingWebhook/82050c5ac3ae4f1cb0ea0c2bd9f6acbc/64936cee-420e-4608-bd6f-9df66783683f'
    Planista: string = 'https://grafpol.webhook.office.com/webhookb2/06873105-0813-4575-bf7f-7a145ba2db4a@7e34a445-4e65-4d9e-ab09-1b4049dbd381/IncomingWebhook/e8f501ff93d643bf967e8c20e0082bfa/64936cee-420e-4608-bd6f-9df66783683f'
  
}


export class TeamsMailgroups {
    Handel: string = 'GF_HANDEL@grafpol.com'
    Prod: string = 'GF_PROD@grafpol.com'
    Studio: string = 'GF_STUDIO@grafpol.com'
    Zakupy: string = 'GF_ZAKUPY@grafpol.com'
    Technologia: string = 'GF_TECHNOLOGIA@grafpol.com'
    Quality: string = 'GF_QUALITY@grafpol.com'
    Planista: string = 'GF_PLANISTA@grafpol.com'
    JM: string = 'GF_JM_TEST1@grafpol.com'
}

